import React, { useEffect } from 'react';
import { CheckIcon, XMarkIcon, InformationCircleIcon } from './Icons';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 6000); // Auto-dismiss after 6 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  const successColors = 'bg-teal-600';
  const errorColors = 'bg-red-600';
  const infoColors = 'bg-blue-600';
  
  let bgColor = infoColors;
  if (type === 'success') bgColor = successColors;
  else if (type === 'error') bgColor = errorColors;

  const Icon = type === 'success' ? CheckIcon : (type === 'error' ? XMarkIcon : InformationCircleIcon);

  return (
    <div className="animate-fade-in-left max-w-sm w-full">
      <div className={`flex items-center gap-3 py-4 px-6 rounded-2xl shadow-2xl text-white ${bgColor}`}>
        <div className="flex-shrink-0 bg-white/20 p-2 rounded-full">
            <Icon className="h-5 w-5" />
        </div>
        <div className="flex-grow">
            <span className="font-bold text-sm block leading-tight">{message}</span>
        </div>
        <button onClick={onClose} className="flex-shrink-0 ml-2 p-1 rounded-full hover:bg-white/20 transition-colors">
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
      <style>{`
        @keyframes fade-in-left {
          0% { opacity: 0; transform: translateX(50px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        .animate-fade-in-left {
          animation: fade-in-left 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </div>
  );
};

export default Toast;